import { InfoSet } from "../InfoSets/InfoSet";
import { Dictionary } from "../Utils/Dictionary";
import { StringUtils } from "../Utils/StringUtils";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

export class CategoryMap /*implements ISerializable*/ implements ObjectSerializer {
    public Name: string;
    public Value: string;

    constructor() {
        this.Name = "";
        this.Value = "";
    }

	public Write(obj: any, context: any): void {
		obj.category_map = {};
        obj = obj.category_map

		obj.name = this.Name;
		obj.value = this.Value;
	}

	public Read(obj: any, context: any): void {
        if (!obj.category_map)
			throw new Error();
        obj = obj.category_map;

		if (obj.name !== undefined)
			this.Name = obj.name;

		if (obj.value !== undefined)
			this.Value = obj.value;
	}
}

export class CategoryMapTable implements ObjectSerializer {
    protected _table: Dictionary<string, CategoryMap>;

    constructor() {
        this._table = new Dictionary<string, CategoryMap>();
    }

    public Add(name: string, value: string): boolean {
        if (StringUtils.IsNullOrEmpty(name))
            return false;
        if (StringUtils.IsNullOrEmpty(value)) {
            this._table.Remove(name);
            return false;
        }

        if (this._table.ContainsKey(name)) {
            this._table.Item(name).Value = value;
            return true;
        }
            
        var attrEntry = new CategoryMap();
        attrEntry.Name = name;
        attrEntry.Value = value;

        return this._table.Add(name, attrEntry);
    }

    public AddMap(categoryMap: CategoryMap): boolean {
        if (categoryMap == null)
            return false;

        if (this._table.ContainsKey(categoryMap.Name)) {
            this._table.Remove(categoryMap.Name);
        }

        return this._table.Add(categoryMap.Name, categoryMap);
    }

    public Clear(): void {
        this._table.Clear();
    }

    public Count(): number {
        return this._table.Count;
    }

    public GetCategory(name: string): string {
        var result = "";

        if (this._table.ContainsKey(name)) {
            result = this._table.Item(name).Value;
        }
        return result;
    }

	public Write(obj: any, context: any): void {
		obj.category_map_table = {};
        obj = obj.category_map_table;

		obj.entries = [];
		ObjSerUtils.WriteObjSerCollection(obj.entries, this._table.Values(), context);
	}

	public Read(obj: any, context: any): void {
        if (!obj.category_map_table)
			throw new Error();
        obj = obj.category_map_table;

		this.Clear();

		if (obj.entries !== undefined) {
			obj.entries.forEach((value: any) => {
				let entry = new CategoryMap();
				entry.Read(value, context);
				this.AddMap(entry);
			}, this);
		}
	}
}
